import { loadable } from '@shared/core/loadableFromNamedExport';

export const AddCashFundDialogV2Lazy = loadable(() => import('./AddCashFundDialogV2'), 'AddCashFundDialogV2');
